import { configConstants } from "../constants";
import { configService, reportService } from "../services";
import { handleErrors } from "../../utils";

export const configActions = {
  getAllCustomers,
  getActiveCustomers,
  getAllChannels,

  getProjectsByCustomerId,
  filterProjectByCustomerId,
  getReportsByCustomerId,

  setSeleCustomerConfigReportsPageNum,
  setActiveConfigReportRow,

  resetProjectsStores,

  updateSeleCustomerField,

  resetDocsActiveTab,
  toggleDocsActiveTab,

  resetDocsInstances,
  loadDocsInstances,

  resetDocumentDeliveryData,
  loadDocumentDeliveryData,

  resetFilesProjectsStores,
  resetDocsProjectsStores,
  resetExecReportsProjectsStores,
  resetConfigReportsProjectsStores,
  resetDashboardProjectsStores,

  resetWizardProjectsStores,

  activateCustomer,
  deactivateCustomer,

  updateCustomer,
  insertCustomer,
  resetSelectedConfigCustomer,

  setFilterStr,
  setNewCustomerStatus,
  setCustomerEditMode,

  toggleCustomerActiveTab,

  resetConfigNewCustomer,
  updateNewCustomerField,

  toggleModalConfirm,
  setConfirmDialogHandler,

  getPlatformNames,

  toggleEditConfigReportModal,
  toggleCopyNewConfigReportModal,

  toggleExpandCustomer,

  setExternalUserData,

  setDefaultSearchPeriod,

  filterFilesViewCustomers,
  filterDocsViewCustomers,

  clearFilterFilesViewCustomers,
  clearFilterDocsViewCustomers,

  toggleDocsViewActiveTab,

  setTagsOptions,

  setExcelUploadYear,

  getLastUploadList,

  getReportsDescriptionsJson,
};

function getReportsDescriptionsJson() {
  return async (dispatch) => {
    dispatch(request());
    try {
      var reportsDescriptions =
        (await configService.getReportsDescriptionsJson()) || [];
      dispatch(success(reportsDescriptions));
    } catch (error) {
      handleErrors(error, dispatch);
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: configConstants.GET_REPORTS_DESCS_REQUEST };
  }

  function success(reportsDescriptions) {
    return {
      type: configConstants.GET_REPORTS_DESCS_SUCCESS,
      reportsDescriptions,
    };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function getLastUploadList() {
  return (dispatch) => {
    dispatch(request());
    var params = {
      PageSize: 5,
      PageNumber: 1,
    };
    configService.getLastUploadList(params).then(
      (lastUploads) => dispatch(success(lastUploads)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GET_UPLOAD_LIST_REQUEST };
  }

  function success(lastUploads) {
    return { type: configConstants.GET_UPLOAD_LIST_SUCCESS, lastUploads };
  }

  function failure(error) {
    return { type: configConstants.GET_UPLOAD_LIST_FAILURE, error };
  }
}

function toggleDocsViewActiveTab(tab) {
  return {
    type: configConstants.TOGGLE_DOCS_VIEW_ACTIVE_TAB,
    tab,
  };
}

function setExcelUploadYear(excelUploadYear) {
  return {
    type: configConstants.SET_EXCEL_UPLOAD_YEAR,
    excelUploadYear,
  };
}

function clearFilterFilesViewCustomers() {
  return {
    type: configConstants.CLEAR_FILTER_FILES_SEARCH_CUSTOMERS,
  };
}

function clearFilterDocsViewCustomers() {
  return {
    type: configConstants.CLEAR_FILTER_DOCUMENTS_SEARCH_CUSTOMERS,
  };
}

function filterFilesViewCustomers(customers) {
  return {
    type: configConstants.FILTER_FILES_SEARCH_CUSTOMERS,
    customers,
  };
}

function filterDocsViewCustomers(customers) {
  return {
    type: configConstants.FILTER_DOCUMENTS_SEARCH_CUSTOMERS,
    customers,
  };
}

function setTagsOptions(tagsOptions, tagsIcons) {
  return {
    type: configConstants.SET_TAGS_OPTIONS,
    tagsOptions,
    tagsIcons,
  };
}

function setDefaultSearchPeriod(defaultSearchPeriod) {
  return {
    type: configConstants.SET_DEFAULT_SEARCH_PERIOD,
    defaultSearchPeriod,
  };
}

function setExternalUserData(customerId) {
  // getting subcustomers and projects and subcustomer projects
  return async (dispatch) => {
    dispatch(request());
    try {
      const projects =
        ((await configService.getProjectsByCustomerId(customerId, true)) || {})
          .Projects || [];
      const customers = await configService.getCustomersByParentId(customerId); // this is globalId
      dispatch(success(customers, projects));
      // foreach subcustomer get its projects 
    } catch (error) {
      handleErrors(error, dispatch);
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: configConstants.GETACTIVE_CUSTOMERS_REQUEST };
  }

  function success(customers, projects) {
    return {
      type: configConstants.GETACTIVE_CUSTOMERS_SUCCESS,
      customers,
      projects,
    };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function toggleExpandCustomer(id) {
  return { type: configConstants.TOGGLE_EXPAND_CUSTOMER, id };
}

function getAllCustomers() {
  return (dispatch) => {
    dispatch(request());
    return configService.getAllCustomers().then(
      (customers) => dispatch(success(customers)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GET_ALL_CUSTOMER_REQUEST };
  }

  function success(customers) {
    return { type: configConstants.GETALL_CUSTOMERS_SUCCESS, customers };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function getActiveCustomers(keepProjFilter, storeState) {
  return (dispatch) => {
    dispatch(request());
    configService.getActiveCustomers().then(
      (customers) => dispatch(success(customers, keepProjFilter, storeState)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETACTIVE_CUSTOMERS_REQUEST };
  }

  function success(customers, keepProjFilter, storeState) {
    return {
      type: configConstants.GETACTIVE_CUSTOMERS_SUCCESS,
      customers,
      keepProjFilter,
      storeState,
    };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function getPlatformNames() {
  return (dispatch) => {
    dispatch(request());
    configService.getPlatformNames().then(
      (data) => dispatch(success(data)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(platformNames) {
    return { type: configConstants.GET_PLATFORMNAMES_SUCCESS, platformNames };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function getProjectsByCustomerId(globalId, view, isExternalUser) {
  return (dispatch) => {
    dispatch(request());
    return configService.getProjectsByCustomerId(globalId, isExternalUser).then(
      (data) => {
        let projects = [];
        if (data.Projects && data.Projects.length) {
          projects = data.Projects;
        }
        if (view === "documentsView") {
          dispatch(
            success(configConstants.GET_DOCS_PROJECTS_SUCCESS, projects)
          );
        } else if (view === "filesView") {
          dispatch(
            success(configConstants.GET_FILES_PROJECTS_SUCCESS, projects)
          );
        } else if (view === "execReportsView") {
          dispatch(
            success(configConstants.GET_EXEC_REPORTS_PROJECTS_SUCCESS, projects)
          );
        } else if (view === "configReportsView") {
          dispatch(
            success(
              configConstants.GET_CONFIG_REPORTS_PROJECTS_SUCCESS,
              projects
            )
          );
        } else if (view === "dashboardView") {
          dispatch(
            success(configConstants.GET_DASHBOARD_PROJECTS_SUCCESS, projects)
          );
        } else if (view === "configView") {
          return dispatch(
            successInfo(configConstants.GET_CONFIG_CUSTOMER_DATA_SUCCESS, data)
          );
        } else if (view === "wizardView") {
          return dispatch(
            successInfo(configConstants.GET_WIZARD_PROJECTS_SUCCESS, data)
          );
        } else {
          dispatch(
            success(configConstants.GET_FILES_PROJECTS_SUCCESS, projects)
          );
          dispatch(
            success(configConstants.GET_DOCS_PROJECTS_SUCCESS, projects)
          );
          dispatch(
            success(configConstants.GET_EXEC_REPORTS_PROJECTS_SUCCESS, projects)
          );
          dispatch(
            success(
              configConstants.GET_CONFIG_REPORTS_PROJECTS_SUCCESS,
              projects
            )
          );
          dispatch(
            success(configConstants.GET_DASHBOARD_PROJECTS_SUCCESS, projects)
          );
        }
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(type, projects) {
    return { type, projects };
  }

  function successInfo(type, data) {
    return { type, data };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function filterProjectByCustomerId(globalId, view) {
  return {
    type: configConstants.FILTER_PROJECTS_BY_CUSTOMERID,
    globalId,
    view,
  };
}

function getReportsByCustomerId(CustomerId, PageNumber, Size) {
  return (dispatch) => {
    dispatch(request());
    var params = {
      CustomerId,
      PageNumber,
      Size,
    };
    return reportService.getConfiguredReports(params).then(
      (data) => {
        dispatch(success(data.Data, data.TotalPages));
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(reports, TotalPages) {
    return {
      type: configConstants.GET_CUSTOMER_CONFIG_REPORTS_SUCCESS,
      reports,
      TotalPages,
    };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function setActiveConfigReportRow(rowIndex) {
  return {
    type: configConstants.SET_CUSTOMER_CONFIG_REPORT_ACTIVE_ROW,
    rowIndex,
  };
}

function setSeleCustomerConfigReportsPageNum(pageNumber) {
  return {
    type: configConstants.SET_SELE_CUST_CONFIG_REPOPRTS_PAGE_NUMBER,
    pageNumber,
  };
}

function resetProjectsStores() {
  return { type: configConstants.RESET_VIEWS_PROJECTS };
}

function resetFilesProjectsStores() {
  return { type: configConstants.RESET_FILES_VIEWS_PROJECTS };
}

function resetDocsProjectsStores() {
  return { type: configConstants.RESET_DOCS_VIEWS_PROJECTS };
}

function resetExecReportsProjectsStores() {
  return { type: configConstants.RESET_EXEC_REPORTS_VIEWS_PROJECTS };
}

function resetConfigReportsProjectsStores() {
  return { type: configConstants.RESET_CONFIG_REPORTS_VIEWS_PROJECTS };
}

function resetDashboardProjectsStores() {
  return { type: configConstants.RESET_DASHBOARD_VIEWS_PROJECTS };
}

function resetWizardProjectsStores() {
  return { type: configConstants.RESET_WIZARD_VIEWS_PROJECTS };
}

function resetDocsActiveTab() {
  return { type: configConstants.RESET_DOCS_ACTIVE_TAB };
}

function toggleDocsActiveTab(tab, index) {
  return { type: configConstants.TOGGLE_DOCS_ACTIVE_TAB, tab, index };
}

function resetDocsInstances() {
  return { type: configConstants.RESET_DOCS_INSTANCES };
}

function loadDocsInstances(docId, index) {
  return (dispatch) => {
    dispatch(request());
    configService.getDocInstances(docId).then(
      (data) => dispatch(success(data.Data, index)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(instances, index) {
    return { type: configConstants.UPDATE_DOCS_INSTANCES, instances, index };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function resetDocumentDeliveryData() {
  return { type: configConstants.RESET_DOC_BOUNCEBACKS };
}

function loadDocumentDeliveryData(params, index) {
  return (dispatch) => {
    dispatch(request());
    configService.getDocumentDeliveryData(params).then(
      (data) => dispatch(success(data?.BounceBackItems, index)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(docDeliveryData, index) {
    return {
      type: configConstants.GET_DOCUMENT_CHANNEL_DELIVERY_DATA,
      docDeliveryData,
      index,
    };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function getAllChannels(params) {
  return (dispatch) => {
    dispatch(request());
    configService.getAllChannels(params).then(
      (channels) => dispatch(success(channels)),
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(channels) {
    return { type: configConstants.GETALL_CHANNELS_SUCCESS, channels };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function resetSelectedConfigCustomer() {
  return { type: configConstants.RESET_CONFIG_SELECTED_CUSTOMER };
}

function updateSeleCustomerField(field, value) {
  return { type: configConstants.UPDATE_CONFIG_CUSTOMER_DATA, field, value };
}

function resetConfigNewCustomer() {
  return { type: configConstants.RESET_CONFIG_NEW_CUSTOMER };
}

function updateNewCustomerField(field, value) {
  return {
    type: configConstants.UPDATE_CONFIG_NEW_CUSTOMER_DATA,
    field,
    value,
  };
}

function setFilterStr(filterStr) {
  return { type: configConstants.SET_FILTER_STR, filterStr };
}

function setNewCustomerStatus(isNewCustomer) {
  return { type: configConstants.SET_NEW_CUSTOMER_STATUS, isNewCustomer };
}

function toggleCustomerActiveTab(tab) {
  return { type: configConstants.TOGGLE_CUSTOMER_ACTIVE_TAB, tab };
}

function toggleModalConfirm(modalConfirm) {
  return { type: configConstants.TOGGLE_MODAL_CONFIRM, modalConfirm };
}

function setConfirmDialogHandler(confirmDialogHandler) {
  return {
    type: configConstants.SET_CONFIRM_DIALOG_HANDLER,
    confirmDialogHandler,
  };
}

function toggleEditConfigReportModal(isOpen, report, repDescObjRef) {
  return {
    type: configConstants.TOGGLE_MODAL_EDIT_CONFIG_REPORT,
    isOpen,
    report,
    repDescObjRef,
  };
}

function toggleCopyNewConfigReportModal(isOpen, report, repDescObjRef) {
  return {
    type: configConstants.TOGGLE_MODAL_COPY_NEW_CONFIG_REPORT,
    isOpen,
    report,
    repDescObjRef,
  };
}

function setCustomerEditMode(editMode) {
  return { type: configConstants.SET_CUSTOMER_EDIT_MODE, editMode };
}

function activateCustomer(customerId) {
  return (dispatch) => {
    dispatch(request());
    return configService.activateCustomer(customerId).then(
      () => dispatch(success()),
      (error) => {
        handleErrors(error, dispatch);
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success() {
    return { type: configConstants.ACTIVATE_CONFIG_CUSTOMER };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function deactivateCustomer(customerId) {
  return (dispatch) => {
    dispatch(request());
    return configService.deactivateCustomer(customerId).then(
      () => dispatch(success()),
      (error) => {
        handleErrors(error, dispatch);
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success() {
    return { type: configConstants.DEACTIVATE_CONFIG_CUSTOMER };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function updateCustomer(customerObj) {
  return (dispatch) => {
    dispatch(request());
    return configService.updateCustomer(customerObj).then(
      (data) => dispatch(success(data)),
      (error) => {
        handleErrors(error, dispatch);
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(data) {
    return { type: configConstants.UPDATE_CONFIG_CUSTOMER, data };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}

function insertCustomer(customerObj) {
  return (dispatch) => {
    dispatch(request());
    return configService.insertCustomer(customerObj).then(
      (data) => dispatch(success(data)),
      (error) => {
        handleErrors(error, dispatch);
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: configConstants.GETALL_REQUEST };
  }

  function success(data) {
    return { type: configConstants.INSERT_CONFIG_CUSTOMER, data };
  }

  function failure(error) {
    return { type: configConstants.GETALL_FAILURE, error };
  }
}
